var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1C0.5 0.447715 0.947716 0 1.5 0H5.5C6.05229 0 6.5 0.447715 6.5 1C6.5 1.55228 6.05229 2 5.5 2H2.5L2.5 5C2.5 5.55228 2.05228 6 1.5 6C0.947715 6 0.5 5.55228 0.5 5V1ZM9.5 5H7.5H5.5V7H7.5V9H5.5V11V13V15H7.5H9.5H11.5V13H13.5V15H15.5V13V11H13.5V9V7H15.5V5H13.5H11.5V7H9.5V5ZM9.5 11H7.5V13H9.5V11ZM9.5 11V9H11.5V11H9.5ZM20.5 1C20.5 0.447715 20.0523 0 19.5 0H15.5C14.9477 0 14.5 0.447715 14.5 1C14.5 1.55228 14.9477 2 15.5 2H18.5V5C18.5 5.55228 18.9477 6 19.5 6C20.0523 6 20.5 5.55228 20.5 5V1ZM20.5 19C20.5 19.5523 20.0523 20 19.5 20H15.5C14.9477 20 14.5 19.5523 14.5 19C14.5 18.4477 14.9477 18 15.5 18H18.5V15C18.5 14.4477 18.9477 14 19.5 14C20.0523 14 20.5 14.4477 20.5 15V19ZM0.5 19C0.5 19.5523 0.947715 20 1.5 20H5.5C6.05228 20 6.5 19.5523 6.5 19C6.5 18.4477 6.05228 18 5.5 18H2.5V15C2.5 14.4477 2.05228 14 1.5 14C0.947715 14 0.5 14.4477 0.5 15V19Z",
    fill: "#303141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.bc92bcd0059635971d1f229a88eeb4e0.svg";
export { ForwardRef as ReactComponent };